import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import Head from '../../../../layout/head/Head';
import Content from '../../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, PaginationComponent, Row } from '../../../../components/Component';
import moment from 'moment';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import { fail_retrieve_tenant_profile_roles, loading_retrieve_tenant_profile_roles, reset_retrieve_tenant_profile_roles, success_retrieve_tenant_profile_roles } from '../../../../reducers/auth_tenant/retrieve_tenant_profile_roles_Slice';
import { RETRIVE_PROFILE_DETAILS_ERROR_MSG, RETRIVE_PROFILE_DETAILS_SUCCESS_MSG, RETRIVE_TENANT_PROFILE_ROLES_ERROR_MSG, RETRIVE_TENANT_PROFILE_ROLES_SUCCESS_MSG, UPDATE_TENANT_PROFILE_ROLE_ERROR_MSG, UPDATE_TENANT_PROFILE_ROLE_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_profile_details, loading_retrieve_profile_details, reset_retrieve_profile_details, success_retrieve_profile_details } from '../../../../reducers/auth_tenant/retrieve_profile_details_Slice';
import { RETRIEVE_TENANT_PROFILE_DETAILS_API, TENANT_RETRIEVE_PROMOTION_PROFILE_DETAILS_API, TENANT_RETRIEVE_PROMOTION_PROFILE_ROLES_API, TENANT_TOGGLE_PROMOTION_PROFILE_ROLE_API } from '../../../../api/api_data';
import { useSelector } from 'react-redux';
import AuthTenantNoData from '../../../error/AuthTenantNoData';
import CardTabs from '../../../components/cards/CardTabs';
import * as app_consts from "../../../../utils/app_consts";
import { addThreeDots, formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import { Badge, Card, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalHeader, Spinner, UncontrolledDropdown } from 'reactstrap';
import { fail_update_tenant_profile_role, loading_update_tenant_profile_role, reset_update_tenant_profile_role, success_update_tenant_profile_role } from '../../../../reducers/auth_tenant/update_tenant_profile_role_Slice';
import LabelText from '../../../components/text/LabelText';

const PromotionEmployeeDetails = ({ tenant_info, user_info }) => {

 const { mobile_number } = useParams();
 const dispatch = useDispatch();
 const navigate = useNavigate();

 const [loading, setLoading] = useState(true);
 const [error, setError] = useState("");
 const [employee_data, setEmployeeData] = useState([]);
 const [activeCardTab, setActiveCardTab] = useState("Personal Info");
 const [selectedToggleRole, setSeletedToggleRole] = useState("");
 const [toggle_loading, setToggleLoading] = useState(false);
 const [toggle_role_error, setToggleRoleError] = useState("");
 const [onSearch, setonSearch] = useState(true);
 const [itemPerPage, setItemPerPage] = useState(10);
 const [sort, setSortState] = useState("asc");
 const [onSearchText, setSearchText] = useState("");
 const [currentPage, setCurrentPage] = useState(1);
 const [selected_audit, setSelectedAudit] = useState("");
 const [audit_trails_modal, setAuditTrailsModal] = useState(false);

 // Change Page
 const paginate = (pageNumber) => setCurrentPage(pageNumber);

 useEffect(() => {
  retrieve_profile_details();
 }, []);

 const retrieve_profile_details = () => {
  setError("");
  setLoading(true);
  dispatch(tenant_auth_actions_helper(loading_retrieve_profile_details, success_retrieve_profile_details, fail_retrieve_profile_details, RETRIVE_PROFILE_DETAILS_ERROR_MSG, RETRIVE_PROFILE_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_PROFILE_DETAILS_API}/${mobile_number}`));
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_profile_roles, success_retrieve_tenant_profile_roles, fail_retrieve_tenant_profile_roles, RETRIVE_TENANT_PROFILE_ROLES_ERROR_MSG, RETRIVE_TENANT_PROFILE_ROLES_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_PROMOTION_PROFILE_ROLES_API}`));
 };

 // Listener
 const retrieve_profile_details_listener = useSelector((state) => state.retrieve_profile_details.retrieve_profile_details);

 useEffect(() => {
  if (retrieve_profile_details_listener.status !== app_consts.IDLE)
  {
   if (retrieve_profile_details_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (retrieve_profile_details_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(retrieve_profile_details_listener.message);
     messageToast(retrieve_profile_details_listener.message, app_consts.FAIL);
    } else if (retrieve_profile_details_listener.status === app_consts.SUCCESS)
    {
     setEmployeeData(retrieve_profile_details_listener.data);
     const timer = setTimeout(() => {
      setLoading(false);
     }, 1000);

     return () => clearTimeout(timer); // cleanup in case the component unmounts
    }
    dispatch(reset_retrieve_profile_details());
   }
  }
 }, [retrieve_profile_details_listener]);

 // Listener
 const retrieve_tenant_profile_roles_listener = useSelector((state) => state.retrieve_tenant_profile_roles.retrieve_tenant_profile_roles);

 useEffect(() => {
  if (retrieve_tenant_profile_roles_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_profile_roles_listener.status === app_consts.LOADING)
   {
    console.log("Tenant Profile Roles Loading");
   } else
   {
    if (retrieve_tenant_profile_roles_listener.status === app_consts.FAIL)
    {
     messageToast(retrieve_tenant_profile_roles_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_profile_roles_listener.status === app_consts.SUCCESS)
    {
     setTenantProfileRoles(retrieve_tenant_profile_roles_listener.data);
    }
    dispatch(reset_retrieve_tenant_profile_roles());
   }
  }
 }, [retrieve_tenant_profile_roles_listener]);

 // Get current list, pagination
 const indexOfLastItem = currentPage * itemPerPage;
 const indexOfFirstItem = indexOfLastItem - itemPerPage;
 const currentItems = employee_data?.audit_trails?.slice(indexOfFirstItem, indexOfLastItem);

 const [tenant_profile_roles, setTenantProfileRoles] = useState([]);

 // Card Tabs
 const tabs = [
  {
   tabName: "Personal Info"
  },
  {
   tabName: "Department & Roles"
  },
  {
   tabName: "Activity"
  }
 ];

 const handleRoleUpdate = (role) => {
  setToggleRoleError("");
  setSeletedToggleRole(role);
  dispatch(tenant_auth_actions_helper(loading_update_tenant_profile_role, success_update_tenant_profile_role, fail_update_tenant_profile_role, UPDATE_TENANT_PROFILE_ROLE_ERROR_MSG, UPDATE_TENANT_PROFILE_ROLE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_TOGGLE_PROMOTION_PROFILE_ROLE_API}`, { role: role, profile_id: employee_data?.profile?.id }));
 };

 // Listen
 const update_tenant_profile_role_listener = useSelector((state) => state.update_tenant_profile_role.update_tenant_profile_role);

 useEffect(() => {
  if (update_tenant_profile_role_listener.status !== app_consts.IDLE)
  {
   if (update_tenant_profile_role_listener.status === app_consts.LOADING)
   {
    setToggleLoading(true);
    setToggleRoleError("");
   } else
   {
    setToggleLoading(false);
    if (update_tenant_profile_role_listener.status === app_consts.FAIL)
    {
     setToggleRoleError(update_tenant_profile_role_listener.message);
     messageToast(update_tenant_profile_role_listener.message, app_consts.FAIL);
    } else if (update_tenant_profile_role_listener.status === app_consts.SUCCESS)
    {
     retrieve_profile_details();
     setSeletedToggleRole("");
     messageToast(update_tenant_profile_role_listener.message, app_consts.SUCCESS);
    }
    dispatch(reset_update_tenant_profile_role());
   }
  }
 }, [update_tenant_profile_role_listener]);

 const toggle = () => setonSearch(!onSearch);


 const view_audit_trail = (audit_trail_id) => {
  setAuditTrailsModal(true);
  // Filter Audit
  const filtered_audit = employee_data?.audit_trails?.filter((audit) => audit?.audit_trail?.id === audit_trail_id);
  setSelectedAudit(filtered_audit[0]);
 };

 const close_modal = () => {
  setAuditTrailsModal(false);
  setSelectedAudit("");
 };
 // Sorting data
 const sortFunc = () => {
  // let defaultData = data;
  // if (sort === "dsc")
  // {
  //   let sortedData = defaultData.sort((a, b) => parseFloat(a.id) - parseFloat(b.id));
  //   setData([...sortedData]);
  // } else if (sort === "asc")
  // {
  //   let sortedData = defaultData.sort((a, b) => parseFloat(b.id) - parseFloat(a.id));
  //   setData([...sortedData]);
  // }
 };
 // onChange function for searching name
 const onFilterChange = (e) => {
  setSearchText(e.target.value);
 };

 return (
  <>
   <Head title="User Details - Regular"></Head>
   <Content>
    <BlockHead size="sm">
     <BlockBetween>
      <BlockHeadContent>
       <BlockTitle tag="h3" page>
        User / <strong className="text-primary small">{employee_data?.user?.first_name ? `${employee_data?.user?.first_name} ${employee_data?.user?.last_name}` : "--"}</strong>
       </BlockTitle>
       <BlockDes className="text-soft">
        <ul className="list-inline">
         <li>
          Last Login: <span className="text-base">{employee_data?.last_login ? moment(employee_data?.last_login).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
         </li>
        </ul>
       </BlockDes>
      </BlockHeadContent>
      <BlockHeadContent>
       <Button
        color="light"
        outline
        className="bg-white d-none d-sm-inline-flex"
        onClick={() => navigate(-1)}
       >
        <Icon name="arrow-left"></Icon>
        <span>Back</span>
       </Button>
       <a
        href="#back"
        onClick={(ev) => {
         ev.preventDefault();
         navigate(-1);
        }}
        className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
       >
        <Icon name="arrow-left"></Icon>
       </a>
      </BlockHeadContent>
     </BlockBetween>
    </BlockHead>
    {
     loading ?
      <>
       <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Employee Details..." />
      </>
      :
      <>
       {
        error ?
         <>
          <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
         </>
         :
         <>
          {
           employee_data ?
            <>
             <Block>
              <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
              {
               activeCardTab === "Personal Info" && (
                <>
                 <div className="card-inner bg-white">
                  <Block>
                   <BlockHead>
                    <BlockTitle tag="h5">Personal Information</BlockTitle>
                   </BlockHead>
                   <div className="profile-ud-list">
                    <div className="profile-ud-item">
                     <div className="profile-ud wider">
                      <span className="profile-ud-label">Full Name</span>
                      <span className="profile-ud-value">{employee_data?.user?.first_name ? `${employee_data?.user?.first_name} ${employee_data?.user?.last_name}` : "--"}</span>
                     </div>
                    </div>
                    <div className="profile-ud-item">
                     <div className="profile-ud wider">
                      <span className="profile-ud-label">Mobile Number</span>
                      <span className="profile-ud-value">{employee_data?.account?.mobile_number || "--"}</span>
                     </div>
                    </div>
                    <div className="profile-ud-item">
                     <div className="profile-ud wider">
                      <span className="profile-ud-label">Email Address</span>
                      <span className="profile-ud-value">{employee_data?.account?.email_address || "--"}</span>
                     </div>
                    </div>
                    <div className="profile-ud-item">
                     <div className="profile-ud wider">
                      <span className="profile-ud-label">Profile Created</span>
                      <span className="profile-ud-value">{employee_data?.profile?.inserted_at ? moment(employee_data?.profile?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                     </div>
                    </div>
                    <div className="profile-ud-item">
                     <div className="profile-ud wider">
                      <span className="profile-ud-label">Profile Status</span>
                      <span className="profile-ud-value">
                       <span className="tb-odr-status">
                        <Badge
                         color={
                          employee_data?.profile?.status === app_consts.ACTIVE
                           ? "success"
                           : "danger"
                         }
                         className="badge-dot"
                        >
                         {employee_data?.profile?.status?.toUpperCase() || "--"}
                        </Badge>
                       </span></span>
                     </div>
                    </div>
                   </div>
                  </Block>
                 </div>
                </>
               )
              }
              {
               activeCardTab === "Department & Roles" && (
                <>
                 <div className="card-inner  bg-white">
                  <Block>
                   <BlockHead>
                    <BlockTitle tag="h5">Department & Roles</BlockTitle>
                   </BlockHead>
                   <div className="profile-ud-list">
                    <div className="profile-ud-item">
                     <div className="profile-ud wider">
                      <span className="profile-ud-label">Department</span>
                      <span className="profile-ud-value">{employee_data?.profile?.department || "--"}</span>
                     </div>
                    </div>
                    <div className="profile-ud-item">
                     <div className="profile-ud wider">
                      <span className="profile-ud-label">Position</span>
                      <span className="profile-ud-value">{employee_data?.profile?.position || "--"}</span>
                     </div>
                    </div>
                   </div>
                   <BlockHead className="mt-4">
                    <BlockTitle tag="h5">Roles</BlockTitle>
                   </BlockHead>
                   {
                    tenant_profile_roles && (
                     <>
                      <div className='bg-white px-4'>
                       <Row className="g-3 align-center">
                        {
                         tenant_profile_roles?.map((role) => {
                          return (
                           <>
                            <Col lg="3">
                             {
                              toggle_loading && selectedToggleRole === role ?
                               <>
                                <div>
                                 <div className='d-flex flx-row justify-content-center align-center'>
                                  <Spinner size="sm" color="primary" className='mx-2' />
                                  <span className='mx-2'>
                                   {formatToSentenceCase(role)}
                                  </span>
                                 </div>
                                </div>
                               </>
                               :
                               <>
                                <div className="form-group">
                                 <div className="form-control-wrap">
                                  <div className="custom-control custom-switch">
                                   <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    name={role}
                                    id={role}
                                    disabled={toggle_loading}
                                    checked={employee_data?.profile?.roles?.includes(role)}
                                    onClick={() => handleRoleUpdate(role)}
                                   />
                                   <label className="custom-control-label" htmlFor={role}>
                                    {formatToSentenceCase(role)}
                                   </label>
                                  </div>
                                 </div>
                                </div>
                               </>
                             }
                             {toggle_role_error && selectedToggleRole === role && (
                              <div className="w-100 mt-2 text-danger">
                               <Icon name="alert-circle" /> {toggle_role_error}{" "}
                              </div>
                             )}
                            </Col>
                           </>
                          );
                         })
                        }
                       </Row>
                      </div>
                     </>
                    )
                   }
                  </Block>
                 </div>
                </>
               )
              }
              {
               activeCardTab === "Activity" && (
                <>
                 <div className="card-inner  bg-white">
                  <Block>
                   <BlockHead>
                    <BlockTitle tag="h5">Activity</BlockTitle>
                   </BlockHead>
                   <Card className="card-stretch">
                    <div className="card-inner-group">
                     <div className="card-inner">
                      <div className="card-title-group">
                       <div className="card-title">
                        <h5 className="title">Audit Trails Listing</h5>
                       </div>
                       <div className="card-tools me-n1">
                        <ul className="btn-toolbar">
                         <li>
                          <Button onClick={toggle} className="btn-icon search-toggle toggle-search">
                           <Icon name="search"></Icon>
                          </Button>
                         </li>
                         <li className="btn-toolbar-sep"></li>
                         <li>
                          <UncontrolledDropdown>
                           <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                            <Icon name="setting"></Icon>
                           </DropdownToggle>
                           <DropdownMenu end>
                            <ul className="link-check">
                             <li>
                              <span>Show</span>
                             </li>
                             <li className={itemPerPage === 10 ? "active" : ""}>
                              <DropdownItem
                               tag="a"
                               href="#dropdownitem"
                               onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(10);
                               }}
                              >
                               10
                              </DropdownItem>
                             </li>
                             <li className={itemPerPage === 15 ? "active" : ""}>
                              <DropdownItem
                               tag="a"
                               href="#dropdownitem"
                               onClick={(ev) => {
                                ev.preventDefault();
                                setItemPerPage(15);
                               }}
                              >
                               15
                              </DropdownItem>
                             </li>
                            </ul>
                            <ul className="link-check">
                             <li>
                              <span>Order</span>
                             </li>
                             <li className={sort === "dsc" ? "active" : ""}>
                              <DropdownItem
                               tag="a"
                               href="#dropdownitem"
                               onClick={(ev) => {
                                ev.preventDefault();
                                setSortState("dsc");
                                sortFunc("dsc");
                               }}
                              >
                               DESC
                              </DropdownItem>
                             </li>
                             <li className={sort === "asc" ? "active" : ""}>
                              <DropdownItem
                               tag="a"
                               href="#dropdownitem"
                               onClick={(ev) => {
                                ev.preventDefault();
                                setSortState("asc");
                                sortFunc("asc");
                               }}
                              >
                               ASC
                              </DropdownItem>
                             </li>
                            </ul>
                           </DropdownMenu>
                          </UncontrolledDropdown>
                         </li>
                        </ul>
                       </div>
                       <div className={`card-search search-wrap ${!onSearch ? "active" : ""}`}>
                        <div className="search-content">
                         <Button
                          className="search-back btn-icon toggle-search"
                          onClick={() => {
                           setSearchText("");
                           toggle();
                          }}
                         >
                          <Icon name="arrow-left"></Icon>
                         </Button>
                         <input
                          type="text"
                          className="form-control border-transparent form-focus-none"
                          placeholder="Search For Audit"
                          value={onSearchText}
                          onChange={(e) => onFilterChange(e)}
                         />
                         <Button className="search-submit btn-icon">
                          <Icon name="search"></Icon>
                         </Button>
                        </div>
                       </div>
                      </div>
                     </div>
                     <div className="card-inner p-0">
                      <table className="table table-orders">
                       <thead className="tb-odr-head">
                        <tr className="tb-odr-item">
                         <th className="tb-odr-info">
                          <span className="tb-odr-total">User</span>
                          <span className="tb-odr-date d-none d-md-inline-block text-start">Message</span>
                         </th>
                         <th className="tb-odr-amount">
                          <span className="tb-odr-total">Audit Type</span>
                          <span className="tb-odr-status d-none d-md-inline-block">Status</span>
                         </th>
                         <th className="tb-odr-info">
                          <span className="tb-odr-id">Timestamp</span>
                         </th>
                         <th className="tb-odr-action">Action</th>
                        </tr>
                       </thead>
                       <tbody className="tb-odr-body">
                        {currentItems.length > 0
                         ? currentItems.map((item) => {
                          return (
                           <tr className="tb-odr-item" key={item.id}>
                            <td className="tb-odr-info">
                             <span className="tb-odr-id">
                              <span className="tb-odr-id">{employee_data?.user?.first_name ? `${employee_data?.user?.first_name} ${employee_data?.user?.last_name}` : "--"}</span>
                             </span>
                             <span className="tb-odr">{item?.message ? addThreeDots(item?.message) : "--"}</span>
                            </td>

                            <td className="tb-odr-amount">
                             <span className="tb-odr-total">
                              <span className="">{item?.audit_type?.toUpperCase() || "--"}</span>
                             </span>
                             <span className="tb-odr-status">
                              <Badge
                               color={
                                item?.status === app_consts.SUCCESS_LOWER
                                 ? "success"
                                 : item?.status === app_consts.REQUEST_LOWER
                                  ? "warning"
                                  : "danger"
                               }
                               className="badge-dot"
                              >
                               {item?.status?.toUpperCase() || "--"}
                              </Badge>
                             </span>
                            </td>
                            <td className="tb-odr-amount">
                             <span className="tb-odr-date">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                            </td>
                            <td className="tb-odr-action">
                             <div className="tb-odr-btns d-none d-sm-inline">
                              <Button color="primary" size="sm" className="btn btn-dim" onClick={() => view_audit_trail(item?.id)}>
                               View
                              </Button>
                             </div>
                             <Button className="btn-pd-auto d-sm-none" onClick={() => view_audit_trail(item?.id)}>
                              <Icon name="chevron-right"></Icon>
                             </Button>
                            </td>
                           </tr>
                          );
                         }
                         )
                         :
                         null
                        }
                       </tbody>
                      </table>
                     </div>
                     <div className="card-inner">
                      {currentItems.length > 0 ? (
                       <PaginationComponent
                        noDown
                        itemPerPage={itemPerPage}
                        totalItems={employee_data?.audit_trails?.length}
                        paginate={paginate}
                        currentPage={currentPage}
                       />
                      ) : (
                       <div className="text-center">
                        <span className="text-silent">No data found</span>
                       </div>
                      )}
                     </div>
                    </div>
                   </Card>
                  </Block>
                 </div>
                 {/* Page Modal */}
                 <Modal isOpen={audit_trails_modal} toggle={close_modal} className="modal-dialog-centered" size={"lg"}>
                  <ModalHeader toggle={close_modal}>Audit Trail Details</ModalHeader>
                  <ModalBody>
                   <Row className="g-4">
                    <LabelText text={employee_data?.user?.first_name ? `${employee_data?.user?.first_name} ${employee_data?.user?.last_name}` : "--"} label="User" />

                    <LabelText text={selected_audit?.message || "--"} label="Message" />
                    <LabelText text={selected_audit?.audit_type?.toUpperCase() || "--"} label="Audit Type" />
                    <LabelText
                     text={selected_audit?.status?.toUpperCase() || "--"}
                     label="Status"
                     badgeStat
                     badgeColor={
                      selected_audit?.status === app_consts.SUCCESS_LOWER
                       ? "success"
                       : selected_audit?.status === app_consts.REQUEST_LOWER
                        ? "warning"
                        : "danger"
                     }
                    />
                    <LabelText text={selected_audit?.inserted_at ? moment(selected_audit?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"} label="Timestamp" />
                    {selected_audit?.data &&
                     (
                      <>
                       <div className="mt-4 ">
                        <BlockHead>
                         <BlockTitle tag="h6">Audit Data</BlockTitle>
                        </BlockHead>
                       </div>
                       {selected_audit?.data &&
                        Object.entries(selected_audit.audit_trail.data)
                         .filter(([_, value]) => !Array.isArray(value)) // Skip arrays
                         .map(([key, value]) => (
                          <LabelText key={formatToSentenceCase(key)} text={String(value)} label={key} />
                         ))}
                      </>
                     )
                    }
                   </Row>
                  </ModalBody>
                 </Modal>
                </>
               )
              }
             </Block>

            </>
            :
            <>
             <AuthTenantNoData tenant_info={tenant_info} no_data_message={"Employee Data Not Found"} />
            </>
          }
         </>
       }
      </>
    }
   </Content>

  </>
 );
};

export default PromotionEmployeeDetails;